/* import __COLOCATED_TEMPLATE__ from './stat-tile-loading-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();